import type { WalkthroughConfig } from "../types";

export const dashboardWalkthrough: WalkthroughConfig = {
  id: "page-dashboard",
  title: "Dashboard Overview",
  description: "Learn how to read and use your MemberOS dashboard effectively.",
  type: "page",
  pageRoute: "/dashboard",
  duration: "1 min",
  category: "pages",
  icon: "LayoutDashboard",
  steps: [
    {
      id: "intro",
      title: "Your Dashboard",
      description: "This is your operational command center. It surfaces the most important metrics, upcoming deadlines, and action items so you always know what needs attention.",
      placement: "center",
      animation: "fade",
      icon: "LayoutDashboard",
    },
    {
      id: "metrics",
      title: "Key Metrics at a Glance",
      description: "The top cards show your most important KPIs: total members, retention rate, engagement score, and revenue. Watch for trends and act on changes quickly.",
      placement: "top",
      animation: "slide-down",
      icon: "BarChart3",
    },
    {
      id: "actions",
      title: "Action Items & Alerts",
      description: "Pending renewals, at-risk members, upcoming events, and tasks appear here. Prioritize what matters most each day.",
      placement: "center",
      animation: "fade",
      icon: "AlertTriangle",
    },
    {
      id: "tip",
      title: "Pro Tip",
      description: "Check your dashboard first thing each day. It's designed to show you the 3-5 most important things happening across your organization right now.",
      placement: "center",
      animation: "scale",
      icon: "Target",
      nextLabel: "Got it! ✓",
    },
  ],
};
